import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';
import { a11y } from '~js/components/a11y';

export class Tracking {
  constructor(el) {
    this.popupContainer = el;
    this.popup = this.popupContainer.querySelector(s.selectors$d.trackingInner);
    this.popupId = this.popup.id;
    this.close = this.popup.querySelector(s.selectors$d.popupClose);
    this.acceptButton = this.popup.querySelector(s.selectors$d.trackingAccept);
    this.enable = this.popupContainer.dataset.enable === 'true';
    this.a11y = a11y;

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          throw error;
        }

        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

        this.enableTracking = !userCanBeTracked && userTrackingConsent === 'no_interaction' && this.enable;

        if (window.Shopify.designMode) {
          this.enableTracking = true;
        }

        this.init();
      }
    );
  }

  init() {
    if (this.enableTracking) {
      this.showPopup();
    }

    this.clickEvents();
  }

  clickEvents() {
    this.close.addEventListener('click', (event) => {
      event.preventDefault();

      window.Shopify.customerPrivacy.setTrackingConsent(false, () => this.hidePopup());
    });

    this.acceptButton.addEventListener('click', (event) => {
      event.preventDefault();

      window.Shopify.customerPrivacy.setTrackingConsent(true, () => this.hidePopup());
    });

    document.addEventListener('trackingConsentAccepted', () => {
      console.log('trackingConsentAccepted event fired');
    });
  }

  showPopup() {
    const popupElement = { id: this.popupId, body: this.popup };
    popups.push(popupElement);
    this.popup.classList.add(c.classes$b.visible);
    this.a11y.trapFocus({
      container: this.popup,
    });
  }

  hidePopup() {
    this.popup.classList.remove(c.classes$b.visible);
    const popupIndex = popups.findIndex((x) => x.id === this.popupId);
    popups.splice(popupIndex, 1);

    if (activePopups < 1) {
      this.a11y.removeTrapFocus();
    } else if (popups.length > 0) {
      const nextPopup = popups[popups.length - 1].body;
      this.a11y.trapFocus({
        container: nextPopup,
      });
    }
  }

  onBlockSelect(evt) {
    if (
      this.popupContainer.contains(evt.target) &&
      this.enableTracking &&
      !this.popup.classList.contains(c.classes$b.visible)
    ) {
      this.showPopup();
      this.popup.classList.add(c.classes$b.selected);
      this.popup.parentNode.classList.add(c.classes$b.hasBlockSelected);
    }
  }

  onBlockDeselect(evt) {
    if (this.popupContainer.contains(evt.target)) {
      this.popup.classList.remove(c.classes$b.selected);
      this.popupContainer.classList.remove(c.classes$b.hasBlockSelected);
      this.hidePopup();
    }
  }

  onDeselect() {
    this.popup.classList.remove(c.classes$b.selected);
    this.popupContainer.classList.remove(c.classes$b.hasBlockSelected);
    this.hidePopup();
  }
}